import React, { useState, useEffect } from "react";
import { Button, Upload, Col, Row, Popconfirm } from "antd";
import { Moment } from "../../helpers";
import { DeleteOutlined, CameraFilled } from "@ant-design/icons";
import { removeFileItem } from "antd/lib/upload/utils";
import { JobService } from "../../services";
import "react-fancybox/lib/fancybox.css";
import Gallery from "../gallery/gallery-list";
import { JobImageUpload } from "./JobImageUpload";
import InformStore from "../../stores/InformStore";
import { photos } from "../gallery/photos";
export const JobGalleryView = ({
  jobId,
  job,
  //   onDeleteBeforeImages,
  //   onDeleteAfterImages,
  defaultMode,
  onReload,
}) => {
  const [beforeImages, setBeforeImages] = useState([]);
  const [afterImages, setAfterImages] = useState([]);
  const [mode, setMode] = useState(defaultMode);
  const [visibleUploadForm, setVisibleUploadForm] = useState(false);

  useEffect(() => {
    if (defaultMode == "undefined") {
      setMode("view");
    }
    let gallery1 = [];
    job.beforeImages.map((photo) => {
      gallery1.push({
        id: photo.id,
        original: photo.url,
        thumbnail: photo.thumbnail,
        description: photo.description,
        size: photo.size,
        extension: photo.extension,
        url: photo.url,
        height: 1,
        width: 1,
        image: photo.url,
      });
    });
    setBeforeImages(gallery1);
  }, [job]);

  useEffect(() => {
    let gallery2 = [];
    job.afterImages.map((photo) => {
      gallery2.push({
        id: photo.id,
        original: photo.url,
        thumbnail: photo.thumbnail,
        description: photo.description,
        size: photo.size,
        extension: photo.extension,
        url: photo.url,
        height: 1,
        width: 1,
        image: photo.url,
      });
    });
    setAfterImages(gallery2);
  }, [job]);

  const getJob = (id) => {
    JobService.view(id).then((rs) => {
      const data = rs.data.data;
      InformStore.setJob(data);
    });
  };

  const onDeleteBeforeImages = (item) => {
    JobService.deleteFile(item.id).then(() => {});
  };
  const onDeleteAfterImages = (item) => {
    JobService.deleteFile(item.id).then(() => {});
  };

  return (
    <React.Fragment>
      {/* <Button
        icon={<CameraFilled />}
        onClick={() => setVisibleUploadForm(true)}
      ></Button>
      <JobImageUpload
        visible={visibleUploadForm}
        jobId={job.id}
        onUpload={() => {
          getJob(job.id);
        }}
        onCancel={() => {
          setVisibleUploadForm(false);
          getJob(job.id);
        }}
      /> */}
      <Row gutter={[4, 4]}>
        <Col span={12}>
          <p>รูปภาพก่อนซ่อม</p>
          {mode == "edit" ? (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                position: "relative",
                width: "100%",
                backgroundColor: "rgb(105, 21, 2)",
                justifyContent: "start",
                padding: 2,
              }}
            >
              {beforeImages
                ? beforeImages.map((bi, bkey) => (
                    <div
                      key={bkey}
                      style={{
                        width: "75px",
                        position: "relative",
                        backgroundColor: "#ffffff",
                        padding: 2,
                        margin: 2,
                      }}
                    >
                      <img
                        src={bi.thumbnail}
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                      <Popconfirm
                        title="ต้องการลบรูปนี้ใช่หรือไม่ ?"
                        okText="ใช่"
                        cancelText="ไม่"
                        onConfirm={() => onDeleteBeforeImages(bi)}
                      >
                        <Button
                          type="danger"
                          size="small"
                          icon={<DeleteOutlined />}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                          }}
                        ></Button>
                      </Popconfirm>
                    </div>
                  ))
                : null}
            </div>
          ) : (
            <div>
              <Gallery data={beforeImages} lightbox />
            </div>
          )}
        </Col>
        <Col span={12}>
          <p>รูปภาพหลังซ่อม</p>
         {mode == 'edit' ?(
                       <div
                       style={{
                         display: "flex",
                         flexWrap: "wrap",
                         position: "relative",
                         width: "100%",
                         backgroundColor: "rgb(2, 105, 99)",
                         justifyContent: "start",
                         padding: 2,
                         margin: 2,
                       }}
                     >
                       {afterImages
                         ? afterImages.map((ai, akey) => (
                             <div
                               key={akey}
                               style={{
                                 margin: 2,
                                 padding: 2,
                                 width: "75px",
                                 position: "relative",
                                 backgroundColor: "#ffffff",
                               }}
                             >
                               <img
                                 src={ai.thumbnail}
                                 style={{ maxWidth: "100%", height: "auto" }}
                               />
                               <Popconfirm
                                 title="ต้องการลบรูปนี้ใช่หรือไม่ ?"
                                 okText="ใช่"
                                 cancelText="ไม่"
                                 onConfirm={() => onDeleteAfterImages(ai)}
                               >
                                 <Button
                                   type="danger"
                                   size="small"
                                   icon={<DeleteOutlined />}
                                   style={{
                                     position: "absolute",
                                     top: 0,
                                     right: 0,
                                   }}
                                 ></Button>
                               </Popconfirm>
                             </div>
                           ))
                         : null}
                     </div>
         ):(<Gallery data={afterImages} lightbox/>)}
        </Col>
      </Row>
    </React.Fragment>
  );
};
